<template>
    <main class="content">
        <header class="content-header">
            <section class="content-header-section">
                <h1 class="content-header-title">{{ $t('pages.statistics.list.title') }}</h1>
            </section>
        </header>
        <div class="content-stats">
            <div v-if="loading" class="content-loading">Loading...</div>
            <div v-if="!loading" class="stats-grid">
                <div class="stats-item stats-item-1">
                    <div class="stats-item-title">{{ $t('pages.statistics.kpis.active_users') }}</div>
                    <ul class="stats-item-menu" v-if="stats.activeusers && stats.activeusers.length > 0">
                        <li
                            v-for="item in stats.activeusers"
                            :key="item.group"
                            :class="{ active: active.activeusers === item.group }"
                            @click="changeGroup('activeusers', item.group)"
                        >
                            {{ $t(`pages.statistics.periods.${ item.group }`) }}
                        </li>
                    </ul>
                    <div class="stats-number" v-if="stats.activeusers && stats.activeusers.length > 0">{{ stats.activeusers[active.activeusers].count }}</div>
                </div>
                <div class="stats-item stats-item-2">
                    <div class="stats-item-title">{{ $t('pages.statistics.kpis.users_per_os') }}</div>
                    <ul class="stats-item-menu" v-if="stats.usersperos && stats.usersperos.length > 0">
                        <li
                            v-for="item in stats.usersperos"
                            :key="item.group"
                            :class="{ active: active.usersperos === item.group }"
                            @click="changeGroup('usersperos', item.group)"
                        >
                            {{ $t(`pages.statistics.periods.${ item.group }`) }}
                        </li>
                    </ul>
                    <div class="stats-double" v-if="stats.usersperos && stats.usersperos.length > 0">
                        <div class="element">
                            <div class="icon">
                                <img :src="require('@/assets/images/stats/icn-apple.svg')" alt="">
                            </div>
                            <div class="number">{{ stats.usersperos[active.usersperos].ios }}</div>
                        </div>
                        <div class="element">
                            <div class="number">{{ stats.usersperos[active.usersperos].android }}</div>
                            <div class="icon">
                                <img :src="require('@/assets/images/stats/icn-android.svg')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="stats-item stats-item-3">
                    <div class="stats-item-title">{{ $t('pages.statistics.kpis.users_per_device_type') }}</div>
                    <ul class="stats-item-menu" v-if="stats.usersperfamily && stats.usersperfamily.length > 0">
                        <li
                            v-for="item in stats.usersperfamily"
                            :key="item.group"
                            :class="{ active: active.usersperfamily === item.group }"
                            @click="changeGroup('usersperfamily', item.group)"
                        >
                            {{ $t(`pages.statistics.periods.${ item.group }`) }}
                        </li>
                    </ul>
                    <div class="stats-double" v-if="stats.usersperfamily && stats.usersperfamily.length > 0">
                        <div class="element">
                            <div class="icon">
                                <img :src="require('@/assets/images/stats/icn-phone.svg')" alt="">
                            </div>
                            <div class="number">{{ stats.usersperfamily[active.usersperfamily].phone }}</div>
                        </div>
                        <div class="element">
                            <div class="number">{{ stats.usersperfamily[active.usersperfamily].tablet }}</div>
                            <div class="icon">
                                <img :src="require('@/assets/images/stats/icn-tablet.svg')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="stats-item stats-item-4">
                    <div class="stats-item-title">{{ $t('pages.statistics.kpis.app_recension') }}</div>
                    <ul class="stats-item-menu" v-if="stats.appratings && stats.appratings.length > 0">
                        <li
                            v-for="item in stats.appratings"
                            :key="item.group"
                            :class="{ active: active.appratings === item.group }"
                            @click="changeGroup('appratings', item.group)"
                        >
                            {{ $t(`pages.statistics.months.${ item.group }`) }}
                        </li>
                    </ul>
                    <div class="stats-double" v-if="stats.appratings && stats.appratings.length > 0">
                        <div class="element">
                            <div class="icon">
                                <img :src="require('@/assets/images/stats/icn-apple.svg')" alt="">
                            </div>
                            <div class="number">{{ stats.appratings[active.appratings].ios }}</div>
                        </div>
                        <div class="element">
                            <div class="number">{{ stats.appratings[active.appratings].android }}</div>
                            <div class="icon">
                                <img :src="require('@/assets/images/stats/icn-android.svg')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="stats-item stats-item-5">
                    <div class="stats-item-title">{{ $t('pages.statistics.kpis.travel_registrations') }}</div>
                    <ul class="stats-item-menu" v-if="stats.totaltravelregistrations && stats.totaltravelregistrations.length > 0">
                        <li
                            v-for="item in stats.totaltravelregistrations"
                            :key="item.group"
                            :class="{ active: active.totaltravelregistrations === item.group }"
                            @click="changeGroup('totaltravelregistrations', item.group)"
                        >
                            {{ $t(`pages.statistics.months.${ item.group }`) }}
                        </li>
                    </ul>
                    <div
                        class="stats-number"
                        v-if="stats.totaltravelregistrations && stats.totaltravelregistrations.length > 0"
                    >
                        {{ stats.totaltravelregistrations[active.totaltravelregistrations].count }}
                    </div>
                </div>
                <div v-if="stats.recurringusers365" class="stats-item stats-item-6">
                    <div class="stats-item-title">{{ $t('pages.statistics.kpis.recuring_users_last_year') }}</div>
                    <div class="stats-number">{{ stats.recurringusers365 }}</div>
                </div>
                <div class="stats-item stats-table">
                    <div class="stats-item-title">{{ $t('pages.statistics.kpis.users_i_am_here') }}</div>
                    <ul class="stats-item-menu" v-if="stats.automatictravelregistrations && stats.automatictravelregistrations.length > 0">
                        <li
                            v-for="item in stats.automatictravelregistrations"
                            :key="item.group"
                            :class="{ active: active.automatictravelregistrations === item.group }"
                            @click="changeGroup('automatictravelregistrations', item.group)"
                        >
                            {{ $t(`pages.statistics.months.${ item.group }`) }}
                        </li>
                    </ul>
                    <table v-if="stats.automatictravelregistrations && stats.automatictravelregistrations.length > 0">
                        <tr v-for="item in stats.automatictravelregistrations[active.automatictravelregistrations].items" :key="item.times">
                            <td class="col-no"><strong>{{ item.times }}</strong></td>
                            <td class="col-name">{{ $t('pages.statistics.labels.time_used') }}</td>
                            <td class="col-value"><strong>{{ item.count }}</strong> {{ $t('pages.statistics.labels.users') }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'Statistics',
    module: 'statistics',
    data() {
        return {
            active: {
                activeusers: 0,
                usersperos: 0,
                usersperfamily: 0,
                appratings: 0,
                totaltravelregistrations: 0,
                automatictravelregistrations: 0,
            },
        };
    },
    computed: {
        stats() {
            return this.$store.state[this.$options.module].list;
        },
        loading() {
            return this.$store.state[this.$options.module].requestPending;
        },
    },
    async created() {
        await this.$store.dispatch(`${ this.$options.module }/list`);
    },
    methods: {
        changeGroup(kpi, group) {
            this.active[kpi] = group;
        },
    },
};
</script>
